export default __webpack_public_path__ + "static/media/avatar.850ee683.svg";